import React from 'react';

export default function FileDropUploader({
  onFiles,
  onGeneratePlaceholder,
  disabled,
  accept,
  title = 'Drag & drop files here',
  buttonLabel = 'Generate Placeholder'
}) {
  const inputRef = React.useRef(null);

  const handleDrop = React.useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    if (disabled) return;
    const files = Array.from(event.dataTransfer?.files || []);
    if (files.length && typeof onFiles === 'function') {
      onFiles(files);
    }
  }, [disabled, onFiles]);

  const handleDragOver = React.useCallback((event) => {
    event.preventDefault();
  }, []);

  const handlePick = React.useCallback((event) => {
    if (disabled) return;
    const files = Array.from(event.target?.files || []);
    if (files.length && typeof onFiles === 'function') {
      onFiles(files);
    }
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  }, [disabled, onFiles]);

  return (
    <div
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      style={{
        border: '2px dashed #00BBF9',
        borderRadius: 12,
        padding: 16,
        minHeight: 120,
        display: 'grid',
        placeItems: 'center',
        color: '#9ca3af',
        background: '#0b0b0e'
      }}
    >
      <div style={{ display: 'grid', gap: 8, justifyItems: 'center' }}>
        <div>{title}</div>
        <input
          ref={inputRef}
          type="file"
          multiple
          accept={accept}
          onChange={handlePick}
          aria-label="Upload files"
          disabled={disabled}
          style={{ marginTop: 8 }}
        />
        {typeof onGeneratePlaceholder === 'function' && (
          <button
            type="button"
            onClick={onGeneratePlaceholder}
            disabled={disabled}
            style={{
              marginTop: 8,
              background: '#00BBF9',
              color: '#0b0b0e',
              border: 0,
              padding: '8px 10px',
              borderRadius: 8,
              cursor: disabled ? 'not-allowed' : 'pointer'
            }}
          >
            {buttonLabel}
          </button>
        )}
      </div>
    </div>
  );
}
